import { render } from "./z-page.vue?vue&type=template&id=ad7a849a"
import script from "./z-page.vue?vue&type=script&lang=js"
export * from "./z-page.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__